// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f14c44bb","453":"11b8557c","455":"179df8a7"}[chunkId] + ".chunk.js";
};